import React, { useEffect, useState } from "react";
import { Box, Grid, makeStyles, Paper } from "@material-ui/core";
import Layout from "../../components/layout";
import { getDbInfo } from "./api";

const useStyles = makeStyles(() => ({
  card: {
    padding: "1.5em",
    maxWidth: 480,
  },
  title: {
    marginTop: 0,
    marginBottom: "0.5em",
  },
  subtitle: {
    color: "#7e878b",
    fontSize: 14,
    marginBottom: 16,
  },
  value: {
    fontSize: 24,
    fontWeight: 600,
    color: "#022a6e",
    wordBreak: "break-all",
  },
  error: {
    color: "#c62828",
    fontSize: 14,
  },
}));

const DbConn = () => {
  const classes = useStyles();
  const [dbName, setDbName] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    getDbInfo()
      .then((res) => setDbName(res?.db_name || "—"))
      .catch(() => setError("Не удалось получить имя базы данных"))
      .finally(() => setLoading(false));
  }, []);

  return (
    <Layout title="База данных | SmartRemont|CRM">
      <Box sx={{ padding: "45px 20px 20px" }}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Paper className={classes.card}>
              <h2 className={classes.title}>Подключение к базе данных</h2>
              <div className={classes.subtitle}>
                Имя базы, к которой подключён backend API
              </div>
              {loading ? (
                <div>Загрузка...</div>
              ) : error ? (
                <div className={classes.error}>{error}</div>
              ) : (
                <div className={classes.value}>{dbName}</div>
              )}
            </Paper>
          </Grid>
        </Grid>
      </Box>
    </Layout>
  );
};

export default DbConn;
